export class VisitLeadInput {
  leadId: string;
  visitDate: Date;
  comments?: string;
}
